<main class="wrapper flex w-full flex-col gap-6 p-6">
  <header class="flex min-h-10 items-center justify-between">
    <div>
      <h1 class="flex items-center gap-2 text-xl font-bold text-base-content">
        <span class="h-6 w-1 rounded-full bg-primary"></span>
        GA4 방문자 통계
      </h1>
      <p class="mt-1 text-sm text-base-content/55">사용자 페이지의 활성 사용자 통계를 조회합니다.</p>
    </div>
  </header>

  <section class="card border border-base-200 bg-base-100">
    <div class="card-body p-6">
      <app-dashboard-analytics />
    </div>
  </section>
</main>
